import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, icon, ...props }) {
        const variantStyles = {
          destructive: "bg-red-500",
          success: "bg-green-500", 
          warning: "bg-yellow-500",
          info: "bg-blue-500",
          default: "bg-gray-500"
        }
        
        const iconColor = "text-white"
        
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex w-full">
              <div className={`flex items-center justify-center w-12 h-12 rounded-l-md ${variantStyles[variant || 'default']}`}>
                {icon && <span className={`${iconColor}`}>{icon}</span>}
              </div>
              <div className="flex-1 p-4">
                <div className="grid gap-1">
                  {title && <ToastTitle className="text-foreground">{title}</ToastTitle>}
                  {description && (
                    <ToastDescription className="text-muted-foreground">{description}</ToastDescription>
                  )}
                </div>
                {action}
              </div>
            </div>
            <ToastClose className="absolute right-2 top-2" />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
